"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, Carousel, CarouselApi, CarouselContent, CarouselItem, cn } from "@saridana-core/react-ui-kit";
import { TMainBannersSection } from "@shared/types";
import { WhatsappIcon } from "@shared/ui/custom-icon";
import Image from "next/image";
import { useEffect, useState } from "react";
import { HeroTitle } from "./hero-title";
import { ButtonLink, HeroButton } from "@shared/ui";
type HeroSectionProps = TMainBannersSection & {
  size?: "md" | "sm";
  imageSize?: "md" | "sm";
  sectionClass?: string;
  heroClass?: string;
};
export function HeroSection(t0) {
  const $ = _c(83);
  const {
    secondsToChange: t1,
    banners,
    footnote,
    size: t2,
    imageSize: t3,
    tabs,
    sectionClass: t4,
    heroClass: t5
  } = t0;
  const secondsToChange = t1 === undefined ? 0 : t1;
  const size = t2 === undefined ? "md" : t2;
  const imageSize = t3 === undefined ? "sm" : t3;
  const sectionClass = t4 === undefined ? "" : t4;
  const heroClass = t5 === undefined ? "" : t5;
  const [api, setApi] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);
  let t6;
  let t7;
  if ($[0] !== api) {
    t6 = () => {
      if (!api) {
        return;
      }
      setCurrentIndex(api.selectedScrollSnap());
      api.on("select", () => {
        setCurrentIndex(api.selectedScrollSnap());
      });
    };
    t7 = [api];
    $[0] = api;
    $[1] = t6;
    $[2] = t7;
  } else {
    t6 = $[1];
    t7 = $[2];
  }
  useEffect(t6, t7);
  const currentBanner = banners[currentIndex];
  const delay = secondsToChange * 1000;
  const [, setHasMounted] = useState(false);
  let t8;
  let t9;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setHasMounted(true);
    };
    t9 = [];
    $[3] = t8;
    $[4] = t9;
  } else {
    t8 = $[3];
    t9 = $[4];
  }
  useEffect(t8, t9);
  let t10;
  if ($[5] !== sectionClass) {
    t10 = cn(sectionClass);
    $[5] = sectionClass;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      background: "linear-gradient(272.9deg, #08475B 0%, #1DB0DE 81.62%)"
    };
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  const t12 = size === "md" ? "min-h-[42.5rem] lg:min-h-[716px]" : "min-h-[38.5rem] lg:min-h-[716px]";
  let t13;
  if ($[8] !== heroClass || $[9] !== t12) {
    t13 = cn("relative overflow-hidden w-full h-auto flex flex-col justify-between lg:block", t12, heroClass);
    $[8] = heroClass;
    $[9] = t12;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  let t14;
  if ($[11] !== banners || $[12] !== currentBanner || $[13] !== currentIndex) {
    t14 = currentBanner && currentBanner?.background && currentBanner?.background?.data && <div key={"bg-" + (currentBanner?.background.data.id ?? currentIndex)} className={cn("absolute inset-0 z-1 h-full w-full overflow-hidden", currentBanner?.backgroundMobile?.data ? "hidden lg:block" : "block")} style={{
      animation: "fadeIn 0.4s ease-in-out"
    }}><Image src={banners[currentIndex]?.background?.data?.attributes?.url || ""} alt={banners[currentIndex]?.background?.data?.attributes?.alternativeText || banners[currentIndex]?.background?.data?.attributes?.name || "Pattern"} width={banners[currentIndex]?.background?.data?.attributes?.width || 1000} height={banners[currentIndex]?.background?.data?.attributes?.height || 1000} priority={true} fetchPriority="high" className="h-full w-full object-cover bottom-0 right-0 absolute z-1 max-w-full lg:max-w-[70%] object-center lg:object-left-bottom" /></div>;
    $[11] = banners;
    $[12] = currentBanner;
    $[13] = currentIndex;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== banners || $[16] !== currentBanner || $[17] !== currentIndex) {
    t15 = currentBanner && currentBanner?.backgroundMobile && currentBanner?.backgroundMobile?.data && <div key={"bg-" + (currentBanner?.backgroundMobile.data.id ?? currentIndex)} className="absolute inset-0 z-1 h-full w-full overflow-hidden lg:hidden" style={{
      animation: "fadeIn 0.4s ease-in-out"
    }}><Image src={banners[currentIndex]?.backgroundMobile?.data?.attributes?.url || ""} alt={banners[currentIndex]?.backgroundMobile?.data?.attributes?.alternativeText || banners[currentIndex]?.backgroundMobile?.data?.attributes?.name || "Pattern"} width={banners[currentIndex]?.backgroundMobile?.data?.attributes?.width || 1000} height={banners[currentIndex]?.backgroundMobile?.data?.attributes?.height || 1000} priority={true} fetchPriority="high" className="h-full w-full object-cover bottom-0 right-0 absolute z-1 max-w-full lg:max-w-[70%] object-center lg:object-left-bottom" /></div>;
    $[15] = banners;
    $[16] = currentBanner;
    $[17] = currentIndex;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  const t16 = "content-" + currentIndex;
  let t17;
  if ($[19] !== tabs) {
    t17 = tabs && tabs.length > 0 && <div className="flex gap-4 flex-wrap mb-12 md:mb-[60px]">{tabs.map(_temp)}</div>;
    $[19] = tabs;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== currentBanner) {
    t18 = currentBanner && currentBanner?.logo && currentBanner?.logo?.data && <Image src={currentBanner?.logo?.data?.attributes?.url || "/images/logo-secondary.webp"} alt={currentBanner?.logo?.data?.attributes?.alternativeText || currentBanner?.logo?.data?.attributes?.name || "Logo Secondary"} width={currentBanner?.logo?.data?.attributes?.width || 1000} height={currentBanner?.logo?.data?.attributes?.height || 1000} className="w-[8rem] lg:w-[11.875rem] h-auto mb-3 md:mb-6" />;
    $[21] = currentBanner;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== currentBanner) {
    t19 = currentBanner && currentBanner.logoText && <div className="text-xl font-bold mb-3 md:mb-6 tracking-widest text-primary-100 min-h-[44px] flex items-center">{currentBanner.logoText}</div>;
    $[23] = currentBanner;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] !== currentBanner) {
    t20 = currentBanner && currentBanner.title && currentBanner.titleVariant && <HeroTitle title={currentBanner.title} subtitle={currentBanner.subtitle} variant={currentBanner.titleVariant} />;
    $[25] = currentBanner;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== currentBanner) {
    t21 = currentBanner && currentBanner.footnote && <div className="my-10 text-lg md:text-2xl text-white font-normal min-h-16">{currentBanner.footnote}</div>;
    $[27] = currentBanner;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== currentBanner) {
    t22 = currentBanner && currentBanner.link && currentBanner.linkVariant && currentBanner.linkText && <div className="mt-10"><HeroButton variant={currentBanner.linkVariant} linkText={currentBanner.linkText} link={currentBanner.link} linkIcon={currentBanner.linkIcon} /></div>;
    $[29] = currentBanner;
    $[30] = t22;
  } else {
    t22 = $[30];
  }
  let t23;
  if ($[31] !== currentBanner.description || $[32] !== currentBanner.phone) {
    t23 = (currentBanner.description || currentBanner.phone) && <div className="mt-8 space-y-4 hidden lg:block">{currentBanner.phone && <div className="flex items-center space-x-2 text-white"><WhatsappIcon className="w-5 lg:w-6 lg:h-6" /><span className="font-bold text-md md:text-lg lg:text-xl leading-7">{currentBanner.phone}</span></div>}{currentBanner.description && <div className="text-white text-sm leading-5">{currentBanner.description}</div>}</div>;
    $[31] = currentBanner.description;
    $[32] = currentBanner.phone;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] !== t16 || $[35] !== t17 || $[36] !== t18 || $[37] !== t19 || $[38] !== t20 || $[39] !== t21 || $[40] !== t22 || $[41] !== t23) {
    t24 = <div className="px-4 sm:px-6 xl:px-[60px] pt-20 md:pt-[120px] lg:pb-[120px] relative h-full"><div className="flex flex-col lg:flex-row h-full"><div className="lg:self-center lg:w-[49%] text-white" key={t16}>{t17}{t18}{t19}{t20}{t21}{t22}{t23}</div></div></div>;
    $[34] = t16;
    $[35] = t17;
    $[36] = t18;
    $[37] = t19;
    $[38] = t20;
    $[39] = t21;
    $[40] = t22;
    $[41] = t23;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  const t25 = imageSize === "sm" ? "lg:w-[55%]" : "lg:w-[65%]";
  let t26;
  if ($[43] !== t25) {
    t26 = cn("w-full max-w-[1024px] max-h-[780px] relative lg:absolute lg:bottom-0 lg:right-0 -mx-4 lg:h-full", t25);
    $[43] = t25;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  let t27;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      align: "center",
      loop: true,
      containScroll: false
    };
    $[45] = t27;
  } else {
    t27 = $[45];
  }
  const t28 = !!secondsToChange;
  let t29;
  if ($[46] !== delay || $[47] !== t28) {
    t29 = {
      plugin: "autoplay",
      options: {
        active: t28,
        delay
      }
    };
    $[46] = delay;
    $[47] = t28;
    $[48] = t29;
  } else {
    t29 = $[48];
  }
  let t30;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = {
      plugin: "fade",
      options: {
        active: true
      }
    };
    $[49] = t30;
  } else {
    t30 = $[49];
  }
  let t31;
  if ($[50] !== t29) {
    t31 = [t29, t30];
    $[50] = t29;
    $[51] = t31;
  } else {
    t31 = $[51];
  }
  let t32;
  if ($[52] !== banners) {
    t32 = banners.map(_temp2);
    $[52] = banners;
    $[53] = t32;
  } else {
    t32 = $[53];
  }
  let t33;
  if ($[54] !== t32) {
    t33 = <CarouselContent className="h-full" wrapperClassName="h-full">{t32}</CarouselContent>;
    $[54] = t32;
    $[55] = t33;
  } else {
    t33 = $[55];
  }
  let t34;
  if ($[56] !== t31 || $[57] !== t33) {
    t34 = <Carousel opts={t27} setApi={setApi} plugins={t31} className="-mx-4 h-full">{t33}</Carousel>;
    $[56] = t31;
    $[57] = t33;
    $[58] = t34;
  } else {
    t34 = $[58];
  }
  let t35;
  if ($[59] !== t26 || $[60] !== t34) {
    t35 = <div className={t26}>{t34}</div>;
    $[59] = t26;
    $[60] = t34;
    $[61] = t35;
  } else {
    t35 = $[61];
  }
  let t36;
  if ($[62] !== api || $[63] !== banners || $[64] !== currentBanner.phone || $[65] !== currentIndex) {
    t36 = banners?.length > 1 && <div className={cn("absolute z-10 w-full", currentBanner?.phone ? "bottom-12 sm:bottom-2" : "bottom-2")}><div className="flex items-center justify-center space-x-3">{banners.map((_, index_0) => <Button key={`carousel-dot-button-${index_0}`} variant="ghost" className="p-0 m-0 hover:bg-transparent " onClick={() => {
          api?.scrollTo(index_0);
        }}>{index_0 === currentIndex ? <div className="bg-primary-600 rounded-full w-4 h-4 border-2 border-white" /> : <div className="bg-white rounded-full w-4 h-4 opacity-60" />}</Button>)}</div></div>;
    $[62] = api;
    $[63] = banners;
    $[64] = currentBanner.phone;
    $[65] = currentIndex;
    $[66] = t36;
  } else {
    t36 = $[66];
  }
  let t37;
  if ($[67] !== currentBanner.phone) {
    t37 = currentBanner.phone && <div className="lg:hidden bg-transparent absolute bottom-0 w-[292px] h-[44px] sm:h-[52px] flex items-center" style={{
      backgroundImage: "linear-gradient(90deg, #1A7D9B 62.04%, rgba(26, 125, 155, 0) 93.1%)"
    }}><div className="container flex items-center space-x-2 text-white"><WhatsappIcon className="w-5 lg:w-6 lg:h-6" /><span className="font-bold text-md md:text-lg lg:text-xl leading-7">{currentBanner.phone}</span></div></div>;
    $[67] = currentBanner.phone;
    $[68] = t37;
  } else {
    t37 = $[68];
  }
  let t38;
  if ($[69] !== t13 || $[70] !== t14 || $[71] !== t15 || $[72] !== t24 || $[73] !== t35 || $[74] !== t36 || $[75] !== t37) {
    t38 = <div style={t11} className={t13}>{t14}{t15}{t24}{t35}{t36}{t37}</div>;
    $[69] = t13;
    $[70] = t14;
    $[71] = t15;
    $[72] = t24;
    $[73] = t35;
    $[74] = t36;
    $[75] = t37;
    $[76] = t38;
  } else {
    t38 = $[76];
  }
  let t39;
  if ($[77] !== footnote) {
    t39 = footnote && <div className="bg-primary-600 py-4"><div className="container lg:text-center text-sm leading-5 text-white">{footnote}</div></div>;
    $[77] = footnote;
    $[78] = t39;
  } else {
    t39 = $[78];
  }
  let t40;
  if ($[79] !== t10 || $[80] !== t38 || $[81] !== t39) {
    t40 = <section className={t10}>{t38}{t39}</section>;
    $[79] = t10;
    $[80] = t38;
    $[81] = t39;
    $[82] = t40;
  } else {
    t40 = $[82];
  }
  return t40;
}
function _temp2(banner, index) {
  return <CarouselItem key={banner.title + "-" + index} className="relative h-full"><Image src={banner.imageDesktop?.data?.attributes?.url || ""} alt={banner.imageDesktop?.data?.attributes?.alternativeText || banner.imageDesktop?.data?.attributes?.name || ""} width={banner.imageDesktop?.data?.attributes?.width || 1000} height={banner.imageDesktop?.data?.attributes?.height || 1000} className="object-bottom h-full w-full object-cover" /></CarouselItem>;
}
function _temp(tab) {
  return <ButtonLink key={tab.id} {...tab} className="font-semibold rounded-2xl" iconClassName="!size-5" />;
}